/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js';

// Récupération des variables d'environnement (recommandé)
// ou utilisation directe des clés fournies
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://yzsaqudbjkoztxojxuqv.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_DBvSvMaawF2DzClmN7XZIw_RSM2ImRh';

// Initialisation du client Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
